<template>
  <div class="wxsignin">
    <p>微信登录跳转中...</p>
  </div>
</template>
<script>
//import foot from "@/views/admin/components/foot.vue";
import {
  GetUrlParam
} from "@/api/admin/login.js";

export default {
  // components: {
  //   foot
  // },
  data() {
    return {
      key: "",
      payload:"",
      request:{}
    };
  },
  created() {
    this.key = GetUrlParam("yuxie_token"); //获取token的值
    //把jwt分为三部分，取中间payload加密串
    this.payload = this.key.split(".")[1];
    this.request.jwtKey = this.payload
    window.console.warn(this.request);
    this.$store.dispatch("wxLogin", this.request).then(data => {
      window.console.warn("返回数据",data);
      //let data1 = data.data.result;
      if (data.isSuccess) {
        if (data.userData.isverify) {
          this.$store.dispatch("GetPersonalInfo", data.userData).then(item => {
            this.$notify.success({
              title: "提示",
              message: "登录成功",
              duration: 1000
            });
            if (item.userInfo) this.$router.push({ path: "/" });
            else {
              var pathList = [
                { title: "您当前的位置" },
                { title: "首页", path: "/index" },
                { path: "/personal", title: "个人中心" },
                {
                  title: "完善信息"
                }
              ];
              setTimeout(() => {
                this.$store.commit("SET_ROUTELIST", pathList);
              });
              this.$router.push({
                path: "/personal/completeInformation"
              });
            }
          });
        } else {
          this.$router.push({ path: "/bindMobile" });
        }
      } else {
        this.$notify.error({
          title: "提示",
          message: data.errorMsg,
          duration: 3000
        });
        this.$router.push({ path: "/register" });
      }
    });
  },
  watch: {
    
  },

  methods: {
    
  }
};
</script>
